import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-stone-200" data-id="element-20" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-21" data-mp="22divwowf5p6l">
        <div className="text-center mb-16" data-id="element-22" data-mp="1ydi7qcjipzmc">
          <p className="text-blue-700 font-bold tracking-widest uppercase mb-2" data-id="element-23" data-mp="1yet9k6tekxat">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-blue-950" data-id="element-24" data-mp="15pw0mub30cuq">
            <span className="text-orange-600" data-id="element-25" data-mp="1jgirk0aloyg9">5</span> PROFESSIONAL BONUS GUIDES
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-26" data-mp="1epiv0w5e8iea">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-stone-50 border border-stone-200 rounded-2xl p-8 shadow-sm shadow-blue-950/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="qzy9q6lrp91u" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-blue-950 text-orange-500 px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-28" data-mp="2ohiqwnwixinp">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-white border border-orange-500/50 rounded-full flex items-center justify-center text-orange-600 mb-4" data-id="element-29" data-mp="1vs1z9sgqa5sj">
                <Gift size={24} data-id="element-30" data-mp="20pttwu8rc60f" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-28 text-blue-950" data-id="element-31" data-mp="25q7z84iz51ur">{bonus.title}</h3>
              <p className="text-blue-700 text-sm font-semibold mb-4 border-l-4 border-orange-500 pl-4" data-id="element-32" data-mp="3c739h5ormdwg">
                {bonus.subtitle}
              </p>
              {bonus.intro && <p className="text-slate-800 text-sm mb-4 leading-relaxed" data-id="element-33" data-mp="1h358xro7qjv7">{bonus.intro}</p>}

              <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-34" data-mp="1c4typfu0a7cg">{bonus.bulletsIntro}</p>
              <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-35" data-mp="1q3tnqolfko95">
                {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-36" data-mp="yajffe0s35ds">
                    <CheckCircle2 size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-37" data-mp="tfdv2jn0xyrt" />
                    <span className="text-slate-800 text-sm" data-id="element-38" data-mp="1760u6cwp5qof">{bullet}</span>
                  </li>)}
              </ul>

              {bonus.secondaryBullets && <>
                  <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-39" data-mp="endg3hg4bbwu">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-40" data-mp="jeejq2ztfp5">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-41" data-mp="5awj0o485yev">
                        <CheckCircle2 size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-42" data-mp="3mr4jnyzsaixu" />
                        <span className="text-slate-800 text-sm" data-id="element-43" data-mp="3rp64aocuyqbf">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              <div className="mt-auto space-y-3" data-id="element-44" data-mp="o8yyocavuj00">
                {bonus.system && <div data-id="element-45" data-mp="o6mlecg2kwta">
                    <p className="text-blue-950 font-semibold text-sm mb-2" data-id="element-46" data-mp="9c7yi0tdx39c">{bonus.systemLabel}</p>
                    <p className="text-white font-bold text-xs sm:text-sm tracking-wide bg-blue-950 border-l-4 border-orange-500 rounded-lg px-3 py-2" data-id="element-47" data-mp="ea9t9j06ar0n">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-stone-200" data-id="element-48" data-mp="3f7wpng0dzecs">
                    {bonus.closing.map(line => <p key={line} className="text-blue-950 font-semibold text-sm italic" data-id="element-49" data-mp="3ah6h5twnyvdv">
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}